module.exports = __webpack_public_path__ + "img/p1_r.8c0be6b8.jpg";